import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";
import { effectivePrice } from "@/lib/pricing";

const StoreContext = createContext(null);

export function StoreProvider({ children }) {
  const [basket, setBasket] = useState([]);
  const [basketOpen, setBasketOpen] = useState(false);
  const [username, setUsername] = useState(() => localStorage.getItem("ulti_mc_username") || "");
  const [platform, setPlatform] = useState(() => localStorage.getItem("ulti_mc_platform") || "java");
  const [isGift, setIsGift] = useState(false);
  const [buyerUsername, setBuyerUsername] = useState("");
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("ulti_user_token")) return;
    api.get("/auth/me")
      .then((r) => {
        setUser(r.data);
        if (r.data.ign) setUsername(r.data.ign);
      })
      .catch(() => localStorage.removeItem("ulti_user_token"));
  }, []);

  const loginUser = (token, u) => {
    localStorage.setItem("ulti_user_token", token);
    setUser(u);
    if (u.ign) setUsername(u.ign);
  };

  const logoutUser = () => {
    api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("ulti_user_token");
    setUser(null);
  };

  useEffect(() => {
    if (username) localStorage.setItem("ulti_mc_username", username);
  }, [username]);

  useEffect(() => {
    localStorage.setItem("ulti_mc_platform", platform);
  }, [platform]);

  const addToBasket = (pkg) =>
    setBasket((prev) => {
      const existing = prev.find((i) => i.id === pkg.id);
      if (existing) return prev.map((i) => (i.id === pkg.id ? { ...i, qty: i.qty + 1 } : i));
      return [...prev, { ...pkg, qty: 1 }];
    });

  const removeFromBasket = (id) => setBasket((prev) => prev.filter((i) => i.id !== id));

  const setQty = (id, qty) =>
    setBasket((prev) =>
      qty <= 0 ? prev.filter((i) => i.id !== id) : prev.map((i) => (i.id === id ? { ...i, qty } : i))
    );

  const clearBasket = () => setBasket([]);

  const total = useMemo(() => basket.reduce((s, i) => s + effectivePrice(i) * i.qty, 0), [basket]);
  const count = useMemo(() => basket.reduce((s, i) => s + i.qty, 0), [basket]);

  return (
    <StoreContext.Provider
      value={{
        basket, addToBasket, removeFromBasket, setQty, clearBasket,
        total, count, username, setUsername, platform, setPlatform, basketOpen, setBasketOpen,
        isGift, setIsGift, buyerUsername, setBuyerUsername,
        user, loginUser, logoutUser,
      }}
    >
      {children}
    </StoreContext.Provider>
  );
}

export const useStore = () => useContext(StoreContext);
